<template lang='pug'>
v-select(
  v-bind='$attrs'
  v-bind.props='$props'
  @input='$emit("input", $event)'
  :items='list'
  item-value='id'
  item-text='object_type_name'
)
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import picker from '@/mixins/picker'

export default {
  mixins: [picker],

  props: {
    label: {
      default: 'Выберите тип строения'
    }
  },

  created() {
    this.fetch()
  },

  methods: mapActions('dictionary/objectTypes', ['fetch']),
  computed: mapGetters('dictionary/objectTypes', ['list'])
}
</script>
